import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useApi } from '../api-context.tsx'
import { peopleKeys } from './keys.ts'

/**
 * Data subject requests for one person (GDPR articles 15 and 17, CCPA): the
 * file of everything held about them, and erasing them.
 *
 * Erasure is the one action in the app that cannot be undone, so it is armed
 * by typing the person's full name — the server checks the same thing.
 */
export function usePersonPrivacy(person: { id: string; fullName: string }, apiBaseUrl: string) {
  const api = useApi()
  const queryClient = useQueryClient()
  const [confirmName, setConfirmName] = useState('')
  const erase = useMutation({
    mutationFn: async () => {
      const { data, error } = await api.api.v1
        .people({ id: person.id })
        .erase.post({ confirmName: confirmName.trim() })
      if (error) throw error
      return data
    },
    onSuccess: () => {
      setConfirmName('')
      void queryClient.invalidateQueries({ queryKey: peopleKeys.all() })
    },
  })
  return {
    /** A link that downloads the access-request file (JSON). */
    exportUrl: `${apiBaseUrl}/api/v1/people/${person.id}/data-export`,
    confirmName,
    setConfirmName,
    armed: confirmName.trim() === person.fullName.trim() && person.fullName.trim() !== '',
    erase,
  }
}
